// Native Google Sign-In via the @capgo/capacitor-social-login plugin, accessed
// through the global Capacitor bridge (window.Capacitor.Plugins) — the SAME
// pattern used for native push (lib/nativePush.js). The web bundle does NOT
// import the plugin, so web builds stay clean. On web we fall back to
// Web Google Identity Services auth (handled in Login.jsx).
//
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const WEB_CLIENT_ID = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID;

export function isNativeApp() {
    return typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.();
}

function getPlugin() {
    return window.Capacitor?.Plugins?.SocialLogin || null;
}

// True only when the native app AND the SocialLogin plugin are both available.
export function nativeGoogleAvailable() {
    return isNativeApp() && !!getPlugin() && !!WEB_CLIENT_ID;
}

let initialized = false;

/**
 * Open the native Google account picker (no browser) and return the Google idToken.
 * The idToken is verified server-side at POST /api/auth/google-native.
 */
export async function signInWithGoogleNative() {
    const SocialLogin = getPlugin();
    if (!SocialLogin) throw new Error('SocialLogin plugin unavailable');
    if (!WEB_CLIENT_ID) throw new Error('Missing REACT_APP_GOOGLE_WEB_CLIENT_ID');

    if (!initialized) {
        await SocialLogin.initialize({ google: { webClientId: WEB_CLIENT_ID } });
        initialized = true;
    }

    const res = await SocialLogin.login({
        provider: 'google',
        options: {},
    });

    // @capgo returns { provider, result: { idToken, accessToken, profile } }.
    const idToken = res?.result?.idToken || res?.idToken || res?.result?.id_token;
    if (!idToken) throw new Error('No idToken returned from Google');
    return idToken;
}
